import React, { Component } from 'react';
import { SketchPicker } from 'react-color';

export class ColorEdit extends Component {

    constructor(props) {
        super(props);
        this.onColorPickComplete = this.onColorPickComplete.bind(this);
        this.state = { color: this.props.colorCode };
    }

    async componentDidUpdate(prevProps) {

        if (this.props.colorCode !== prevProps.colorCode) {
            await this.setState({ color:this.props.colorCode});           
        }

    }
    onColorPickComplete(color) {
        this.setState({ color: color.hex });
        this.props.onChangeComplete(color);
    }
    render() {
        const pickerColor = this.state.color;
        return (
            <div className="m15">
                <SketchPicker  color={pickerColor} on
                    onChangeComplete={this.onColorPickComplete} />
            </div>
            );
    }
}

